import PropTypes from 'prop-types';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { ingredientURL } from 'utils/ingredients';

import IngredientCard from './IngredientCard';

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  max-width: ${legacyTheme.breakpoints.values.md}px;
  justify-content: center;
  align-items: stretch;
  ${legacyTheme.breakpoints.match('md')} {
    justify-content: space-between;
    flex-flow: row wrap;
    max-width: 490px;
  }
  ${legacyTheme.breakpoints.match('sm')} {
    flex-flow: row wrap;
    max-width: 340px;
    justify-content: space-around;
  }
`;

const IngredientList = ({ ingredients, showIncludedIn }) => (
  <Wrapper>
    {ingredients.map((item, key) => {
      return (
        <IngredientCard
          key={String(`${item.slug}-${key}`)}
          description={item.description}
          image={ingredientURL(item.picture_name)}
          includedIn={showIncludedIn ? item.included_in : undefined}
          name={item.name}
          usage={item.usage}
        />
      );
    })}
  </Wrapper>
);

IngredientList.propTypes = {
  ingredients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showIncludedIn: PropTypes.bool,
};

IngredientList.defaultProps = {
  showIncludedIn: false,
};

export default IngredientList;
